import { createAction } from "@reduxjs/toolkit";
import { PoolData } from "./reducer";

export const addPoolsData = createAction<{ pools: PoolData[], poolAddresses: string[] }>('pools/addPoolsData');
export const updatePoolsData = createAction<{ pools: PoolData[] }>('pools/updatePoolsData')
// export const updatePoolChartData = createAction<{
//     poolAddress: string
//     chartData: PoolChartEntry[]
//     networkId: SupportedNetwork
// }>('pool/updatePoolChartData')